import { getId } from '@basehub/utils/id/index'

export const getPlaygroundId = () => getId().toLowerCase()

export const getPlaygroundUserId = (pId: string) => 'playground_' + pId

export const getPlaygroundIdFromUserId = (userId: string) => {
  if (!userId.startsWith('playground_')) return null
  return userId.replace('playground_', '')
}

export const isPlaygroundUser = (userId: string | undefined) => {
  return userId?.startsWith('playground_')
}
